<template>
  <tfoot v-if="rows.length > 0">
    <tr style="background-color: #f2f2f28e">
      <td class="text-center p-3">
        <strong style="font-size: 16px">{{
          rows.length > 0 ? 'Sub Total' : $t('common_words.total_mayus')
        }}</strong>
      </td>

      <template v-for="ribbonData in getColumns()">
        <template v-for="ribbon in ribbonData">
          <td v-if="option === 'balanceVariablesByRibbon'" class="text-center">
            {{ ribbon.pocket }}
          </td>
          <td v-if="option === 'balanceVariablesByRibbon'" class="text-center">
            {{ ribbon.cutting }}
          </td>
          <td v-if="option === 'balanceVariablesByRibbon'" class="text-center">
            {{ ribbon.ringing }}
          </td>
          <td class="text-center">
            {{ ribbon.balance }}
          </td>
          <percent-cell-balance
            :value="ribbon.balance"
            :percent="ribbon.percent"
          />
        </template>
      </template>
    </tr>
    <tfoot-totals
      v-if="rows.length > 0"
      :totalColumns="totalColumns"
      :columns="columns"
      :option="option"
    />
  </tfoot>
</template>
<script>
import { getSumOfValorFromArray } from 'src/util/Util.js';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';
import PercentCellBalance from '../Layouts/PercentCellBalance.vue';
import TfootTotals from '../Layouts/TfootTotals.vue';

export default {
  name: 'tfoot-ribbons-balances',
  components: {
    [TfootTotals.name]: TfootTotals,
    [PercentCellBalance.name]: PercentCellBalance,
  },
  props: {
    rows: {
      type: Array | Object,
      default: () => {
        return [];
      },
    },
    columns: {
      type: Array | Object,
      default: () => {
        return [];
      },
    },
    totalColumns: {
      type: Array | Object,
      default: () => {
        return [];
      },
    },
    option: {
      type: String,
      default: 'ribbonsBalances',
    },
  },
  computed: {
    getSizeRows() {
      return Object.values(this.rows).length;
    },
  },
  mixins: [MixinMasters],
  methods: {
    getColumns() {
      const cols = Object.keys(this.columns).map((week) => {
        return this.columns[week].map((ribbon) => {
          const values = this.getTotalColumn(week, ribbon.color_name);
          return {
            ...ribbon,
            balance: values[0],
            percent: values[1],
            pocket: values[2],
            cutting: values[3],
            ringing: values[4],
          };
        });
      });
      return cols;
    },

    getTotalColumn(week, ribbon) {
      let pocket = this.getData('pocket', week, ribbon);
      pocket = getSumOfValorFromArray(pocket);

      const cutting = this.getData('cutting', week, ribbon);
      const ringing = this.getData('ringing', week, ribbon);
      const total =
        pocket -
        getSumOfValorFromArray(cutting) -
        getSumOfValorFromArray(ringing);
      const totalReponse = 1 - total / pocket;
      let percent = '';

      if (Number(total) === 0) percent = '100%';
      else if (Number(pocket) === 0) percent = '0%';
      else
        percent =
          totalReponse == 0
            ? '0%'
            : `${Formatter.formatNumber((totalReponse * 100).toFixed(2))}%`;

      return [
        Formatter.formatNumber(total),
        percent,
        Formatter.formatNumber(pocket),
        Formatter.formatNumber(getSumOfValorFromArray(cutting)),
        Formatter.formatNumber(getSumOfValorFromArray(ringing)),
      ];
    },

    getData(type, week, ribbon) {
      return this.rows
        .map((item) => item.numberLot)
        .map((numberLot) => {
          return this.getSumByType(type, week, ribbon, numberLot);
        });
    },

    getSumByType(type, week, ribbon, numberLot) {
      try {
        const filtered = this.totalColumns[type][week][ribbon][numberLot];
        return Array.isArray(filtered)
          ? getSumOfValorFromArray(filtered)
          : filtered;
      } catch (error) {
        return 0;
      }
    },
  },
};
</script>
